import { Box, Button, Typography } from "@mui/material";

export const BACKGROUND_OPTIONS = [
  { value: "yellow", label: "黃色", color: "#F5C518" },
  { value: "blue", label: "藍色", color: "#3B82F6" },
  { value: "green", label: "綠色", color: "#22C55E" },
  { value: "purple", label: "紫色", color: "#A855F7" },
];

export function backgroundOption(value) {
  return BACKGROUND_OPTIONS.find((option) => option.value === value) || BACKGROUND_OPTIONS[0];
}

export default function BackgroundSelection({ value, onChange }) {
  return (
    <Box>
      <Typography variant="body2" sx={{ color: "#6b7280", mb: 1.5 }}>
        背景
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {BACKGROUND_OPTIONS.map((option) => {
          const selected = option.value === value;

          return (
            <Button
              key={option.value}
              onClick={() => onChange(option.value)}
              sx={{
                minWidth: 0,
                px: 1.5,
                py: 0.75,
                borderRadius: 999,
                border: "1px solid",
                borderColor: selected ? "#111827" : "#e5e7eb",
                bgcolor: selected ? "#f8fafc" : "#fff",
                color: "#111827",
                textTransform: "none",
                fontWeight: 700,
                lineHeight: 1.4,
                boxShadow: "none",
                gap: 1,
                "&:hover": {
                  bgcolor: "#f8fafc",
                  borderColor: selected ? "#111827" : "#d1d5db",
                  boxShadow: "none",
                },
              }}
            >
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  borderRadius: "50%",
                  bgcolor: option.color,
                  border: "1px solid rgba(17, 24, 39, 0.12)",
                  flexShrink: 0,
                }}
              />
              {option.label}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
}
